import axios from "axios";

const api = axios.create({
  // baseURL: process.env.VUE_APP_CONF,
  baseURL: "https://chat-api.posybe.sk/romania",
});

export default api;
